import { useState } from "react";
import { Lock } from "lucide-react";
import { api, setToken } from "@/lib/api";

const inputCls = "w-full rounded-md border border-line bg-black/40 px-4 py-3 text-sm text-cream placeholder:text-ash/60 focus:border-ember focus:outline-none";

export const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const data = await api("/api/auth/login", { method: "POST", body: { email, password } });
      setToken(data.access_token);
      onSuccess(data.user);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="mx-auto max-w-md rounded-md border border-line bg-card2 p-8" data-testid="admin-login-form">
      <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.3em] text-ember">
        <Lock className="h-3.5 w-3.5" /> Editor sign in
      </p>
      <h1 className="mt-3 font-display text-2xl font-extrabold text-cream">Itlu Mee Jaffar — Admin</h1>
      <label className="mt-8 block text-xs font-semibold uppercase tracking-wider text-ash" htmlFor="admin-email">Email</label>
      <input id="admin-email" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={`mt-2 ${inputCls}`} data-testid="admin-email-input" />
      <label className="mt-5 block text-xs font-semibold uppercase tracking-wider text-ash" htmlFor="admin-password">Password</label>
      <input id="admin-password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={`mt-2 ${inputCls}`} data-testid="admin-password-input" />
      {error && <p className="mt-4 text-sm text-ember" role="alert" data-testid="admin-login-error">{error}</p>}
      <button type="submit" disabled={busy} data-testid="admin-login-submit" className="mt-8 w-full rounded-full bg-ember py-3 text-xs font-bold uppercase tracking-wider text-ink transition-colors duration-300 hover:bg-emberHover disabled:opacity-60">
        {busy ? "Signing in…" : "Sign in"}
      </button>
    </form>
  );
};
